import type { QueryClient } from "@tanstack/react-query";
import type {
  Notification,
  PaginatedNotifications,
  UnreadCountResponse,
} from "@/api/notifications";
import type { NotificationsReadEvent } from "@/features/notifications/hooks/useNotificationsWebSocket";

/**
 * Applies a `notification.read` frame (BUG-723): reading a chat thread marks
 * its `chat_message` bell rows read for this user, and the bell must drop at
 * once — it used to sit at 99+ with chat unread at 0.
 */
export function applyNotificationsRead(
  queryClient: QueryClient,
  event: NotificationsReadEvent,
): void {
  queryClient.setQueryData<UnreadCountResponse>(
    ["notifications", "unread-count"],
    (prev) => ({ ...(prev ?? {}), count: event.unread_count }),
  );
  if (event.ids.length === 0) return;
  const ids = new Set(event.ids);
  queryClient.setQueryData<PaginatedNotifications>(
    ["notifications", "list"],
    (prev) =>
      prev
        ? {
            ...prev,
            results: prev.results.map(
              (n: Notification): Notification =>
                ids.has(n.id) ? { ...n, is_read: true } : n,
            ),
          }
        : prev,
  );
}
